import { apiClient } from '@src/config/api';
import {
  ResponseBooleanValue,
  GenerateCodeData,
  ValidationCodeData,
} from '@src/shared/models';

export const AuthApi = {
  generateCode: (data: GenerateCodeData) =>
    apiClient.post<ResponseBooleanValue, GenerateCodeData>(
      '/pincode/generate',
      data
    ),

  validateCode: (data: ValidationCodeData) =>
    apiClient.post<ResponseBooleanValue, ValidationCodeData>(
      '/travel/proposal/execute',
      data
    ),
} as const;
